module.exports = __webpack_public_path__ + "img/520x_lg.97cda149.jpg";